import React, { useEffect, useState } from 'react';
import { ScrollingCarousel } from '@trendyol-js/react-carousel';
import CategoriesFilter from 'components/shared/CategoriesFilter';
import useCollection from 'sdk/hooks/useCollection';
import { getPercent } from 'sdk/utils/assets';
import ViewAll from 'components/shared/ViewAll';
import { Link } from 'react-router-dom';
import ContentSection from 'components/shared/ContentSection';
import CategoriesSelect from 'components/shared/CategoriesSelect';
import styles from './TopAssets.module.scss';

function TopAssets({
  title, collectionId,
  showCategories, showCategoriesSelect, viewAllLink,
  relativeActiveCategory, setRelativeActiveCategory,
  noMargin,
}: {
  collectionId: number,
  title: string,
  showCategories?: boolean,
  showCategoriesSelect?: boolean,
  viewAllLink?: string,
  relativeActiveCategory?: any,
  setRelativeActiveCategory?: any,
  noMargin?: boolean,
}) {
  const [activeCategory, setActiveCategory] = useState<number | string | null>(null)
  const collectionData = useCollection(collectionId)

  useEffect(() => {
    if (relativeActiveCategory) {
      setActiveCategory(relativeActiveCategory)
    } else {
      setActiveCategory(null)
    }
  }, [relativeActiveCategory])

  const items = (collectionData?.data?.items || [])
    .filter((item: any) => {
      if (relativeActiveCategory) {
        return item.category?.id === relativeActiveCategory
      }
      if (activeCategory) {
        return item.category?.id === activeCategory
      }
      return true
    })
    .filter((i) => i.active)

  if (collectionData?.isLoading) {
    return null;
  }

  if (relativeActiveCategory && !items.length) {
    return null;
  }

  return (
    <ContentSection
      title={collectionData.data?.name ?? title}
      headerRight={(
        <>
          {showCategories ? (
            <CategoriesFilter
              value={relativeActiveCategory || activeCategory || ''}
              onChange={setRelativeActiveCategory || setActiveCategory}
              disabledNfts
            />
          ) : null}
          {showCategoriesSelect ? (
            <CategoriesSelect
              onChange={setRelativeActiveCategory || setActiveCategory}
              disabledNfts
            />
          ) : null}
          {viewAllLink ? (
            <ViewAll url={viewAllLink} />
          ) : null}
        </>
      )}
      noMargin={noMargin}
    >
      <ScrollingCarousel className={styles.picks}>
        {items.map((asset: any) => (
          <Link
            key={asset.id}
            className={styles.picksItem}
            to={`/asset/${asset.category?.name}/${asset.ticker}`}
            onMouseDown={(e) => e.preventDefault()}
          >
            <img src={asset?.icon} alt={asset?.ticker} />
            <span className={styles.picksItemChanges}>
              {`${getPercent(asset)}%`}
            </span>
          </Link>
        ))}
      </ScrollingCarousel>
    </ContentSection>
  )
}

export default TopAssets
